module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'activity': true,
      'mobile': _vm.isMobile
    }
  }, [_c('img', {
    staticClass: "activity-img",
    attrs: {
      "src": _vm.imgUrl
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-533df9d3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Promotion.vue
// module id = 613
// module chunks = 1